import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Button, Popover, Modal, message, } from "antd";
import { MyIcon } from "../../common/baseConfig";
export class ExerChoice extends Component {
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
  };
  state = {
    visible: window.notShowModal || localStorage.getItem("subject") ? false : true,
    popVisible: false,
    subIndex: -1,
    subName: "",
    categoryList: [],
    categoryIndex: -1,
    categoryName: "",
  }
  componentDidMount() {
    //获取科目数据
    this.props.actions.fetchGetAllSubject();
    //如果缓存存在获取下拉数据
    let subject = JSON.parse(localStorage.getItem("subject"));
    subject && this.GetQuestionStore(subject.subjectID);

  }
  onSubChange(item) {
    this.setState({
      subIndex: item.ID,
      subName: item.Name,
      categoryList: item.ChildNodeList,
    })
  }
  GetQuestionStore(index) {
    //获取题库
    this.props.actions.fetchGetQuestionStore({ disciplineId: index, Valid: 1 });
  }
  submitSubject() {
    const { subIndex, subName, categoryIndex, categoryName } = this.state;
    if (subIndex === -1) {
      message.warn('请选择任一科目分类提交');
      return;
    }
    if (categoryIndex === -1) {
      this.GetQuestionStore(subIndex);
      localStorage.setItem("subject", JSON.stringify({ subjectName: subName, subjectID: subIndex }));
    } else {
      this.GetQuestionStore(categoryIndex);
      localStorage.setItem("subject", JSON.stringify({ subjectName: categoryName, subjectID: categoryIndex }));
    }

    this.setState({
      visible: false,
    }, () => {
      localStorage.removeItem("store");
    })
  }
  updateStoreData(item) {
    localStorage.setItem("store", JSON.stringify({ storeName: item.Name, storeID: item.ID }));
    this.props.actions.updateQuestionStore({ storeName: item.Name, storeID: item.ID });
    this.setState({
      popVisible: false,
    })
  }
  render() {
    const { disabled } = this.props;
    const { fetchGetAllSubjectSuccess, fetchGetQuestionStoreSuccess, fetchGetQuestionStoreSelect } = this.props.center;

    const { subIndex, categoryList, categoryIndex, popVisible } = this.state;
    let subject = JSON.parse(localStorage.getItem("subject"));
    const dropdown = fetchGetQuestionStoreSuccess && fetchGetQuestionStoreSuccess.length > 0 ?
      fetchGetQuestionStoreSuccess.map(item => (<div className="exer-choice-drop" key={item.ID} onClick={this.updateStoreData.bind(this, item)}>{item.Name}</div>)) : null;

    return (
      <div className="center-exer-choice">
        <Popover
          onVisibleChange={disabled ? () => { } : (visible) => { this.setState({ popVisible: visible }) }}
          visible={popVisible}
          overlayClassName="exer-choice-drops"
          placement="bottom"
          content={subject && fetchGetQuestionStoreSelect ? dropdown : null}
          trigger="click"
        >
          <p className={disabled ? "dropDown-disabled" : "dropDown step9"} onClick={disabled ? () => { } : () => this.setState({
            popVisible: true,
          })}><span>{subject && fetchGetQuestionStoreSelect ? subject.subjectName + "-" + fetchGetQuestionStoreSelect.storeName : "暂无数据"}</span><MyIcon type="iconxiala" className="downIcon" /></p>
        </Popover>
        <Button disabled={disabled} type="theme2" className="choiceBtn step8" onClick={() => this.setState({
          visible: true,
          subIndex: fetchGetAllSubjectSuccess[0].ID,
          subName: fetchGetAllSubjectSuccess[0].Name,
          categoryList: fetchGetAllSubjectSuccess[0].ChildNodeList
        })}>切换考试</Button>
        <Modal
          centered
          wrapClassName="subjectModal"
          maskClosable={false}
          footer={null}
          title={null}
          width={640}
          onCancel={() => this.setState({
            visible: false,
            subIndex: -1,
            subName: "",
            categoryList: [],
            categoryIndex: -1,
            categoryName: "",
          })}
          visible={this.state.visible}
        >
          <div className="choiceModal">
            <div className="subject">
              <h1>
                <span>设置考试</span><span>（科目可选一项）</span>
              </h1>
              {
                fetchGetAllSubjectSuccess && fetchGetAllSubjectSuccess.length > 0 ?
                  (<div className="subjects">
                    {
                      fetchGetAllSubjectSuccess.map(item => (
                        <div className={subIndex === item.ID ? "subitem-active" : "subitem"} key={item.ID} onClick={
                          this.onSubChange.bind(this, item)
                        }>{item.Name}</div>
                      ))
                    }
                  </div>) : (<div className="subjects">
                    <p className="wait">暂无科目选择，请等待管理员上传...</p>
                  </div>)
              }

            </div>
            <div className="category">
              {
                categoryList.length > 0 && <div>
                  {
                    categoryList.map(item => (
                      <div className="second" key={item.ID}>
                        <h2>{item.Name}</h2>
                        <div className="third">
                          <div onClick={() => {
                            this.setState({
                              categoryIndex: item.ID,
                              categoryName: item.Name,
                            })
                          }} className={categoryIndex === item.ID ? "third-item-active" : "third-item"}>全部</div>
                          {
                            item.ChildNodeList.map(it => (
                              <div key={it.ID} className={categoryIndex === it.ID ? "third-item-active" : "third-item"} onClick={() => {
                                this.setState({
                                  categoryIndex: it.ID,
                                  categoryName: it.Name,
                                })
                              }}>{it.Name}</div>
                            ))
                          }
                        </div>
                      </div>
                    ))
                  }
                </div>
              }
            </div>
            <div className="btn">
              <Button type="theme" className="ok" onClick={this.submitSubject.bind(this)}>确认</Button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExerChoice);



// WEBPACK FOOTER //
// ./src/features/center/ExerChoice.js